// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__H9+CK","menu__list":"Menu_menu__list__ffTem"};